/**
 * USSD URL utilities for Android device compatibility
 * Fixes issue where # character gets stripped on Honor, Redmi, and other Android devices
 */

/**
 * Encodes a USSD code for use in tel: URLs
 * Replaces # with %23 to prevent stripping on Android devices
 */
export const formatUssdTelUrl = (ussdCode: string): string => {
  // Remove "tel:" prefix if present, we'll add it back
  const code = ussdCode.replace(/^tel:/, '');
  // Encode # as %23
  const encodedCode = code.replace(/#/g, '%23');
  return `tel:${encodedCode}`;
};

/**
 * Shorthand to navigate to a USSD code
 */
export const dialUssd = (ussdCode: string): void => {
  window.location.href = formatUssdTelUrl(ussdCode);
};
